import * as fr from './fr/translation';
import * as en from './en/translation';

const messages = {
  fr: {
    translation: {
      ...fr
    }
  },
  en: {
    translation: {
      ...en
    }
  }
};

export default messages;
